import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"{{local-class \"box\" from=\"@qonto/ui-kit/components/timeline/box.module.css\"}}\" ...attributes>\n  {{yield}}\n</div>", {
  moduleName: "@qonto/ui-kit/components/timeline/box.hbs"
});